// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	666: 0
};

var installChunk = (data) => {
	var {ids, modules, runtime} = data;
	// add "modules" to the modules object,
	// then flag all "ids" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	for(moduleId in modules) {
		if(__webpack_require__.o(modules, moduleId)) {
			__webpack_require__.m[moduleId] = modules[moduleId];
		}
	}
	if(runtime) runtime(__webpack_require__);
	for(;i < ids.length; i++) {
		chunkId = ids[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[ids[i]] = 0;
	}

}

// no chunk on demand loading

__webpack_require__.C = installChunk;

// no on chunks loaded